import { Injectable } from '@angular/core';
import { PolygonCreatorService } from './polygon-creator.service';

@Injectable({ providedIn: 'root' })
export class IllumPolygonCreatorService {
  constructor(private polygonCreatorService: PolygonCreatorService) {}

  startDrawing(callbackOptions: any): void {
    this.polygonCreatorService.setCallbackOptions(callbackOptions);
    this.polygonCreatorService.startShapeCreationEditor();
  }

  stopDrawing(): void {
    this.polygonCreatorService.stopShapeEditor();
  }

  freezeDrawing(): void {
    this.polygonCreatorService.freezeShapeEditor();
  }

  clearDrawing(): void {
    this.polygonCreatorService.clearShape();
  }

  getPolygon(): any {
    return this.polygonCreatorService.getCurrentShape();
  }
}